<template>
    <form-wrapper class="create-company-form" @form-submit="submit">
        <form-row>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.company.create_company.fields.name.label')"
                    :placeholder="$t('forms.company.create_company.fields.name.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="name"
                    @change="change"
                ></text-input>
            </form-cell>

            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.company.create_company.fields.pib.label')"
                    :placeholder="$t('forms.company.create_company.fields.pib.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="pib"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell width="half">
                <select-input
                    :formData="data"
                    :label="$t('forms.company.create_company.fields.country.label')"
                    :placeholder="$t('forms.company.create_company.fields.country.placeholder')"
                    :isRequired="true"
                    :options="countryOptions"
                    valuePath="countryId"
                    :isSearchable="true"
                    @change="countryChange"
                    @clear="clear"
                ></select-input>
            </form-cell>
            <form-cell width="half">
                <select-input
                    ref="citySelect"
                    :formData="data"
                    :label="$t('forms.company.create_company.fields.city.label')"
                    :placeholder="$t('forms.company.create_company.fields.city.placeholder')"
                    :isRequired="true"
                    :options="cityOptions"
                    valuePath="cityId"
                    :isSearchable="true"
                    @change="change"
                    @clear="clear"
                ></select-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.company.create_company.fields.address.label')"
                    :placeholder="$t('forms.company.create_company.fields.address.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="address"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button type="primary" :isProcessing="isLoading" :label="$t('common.microcopy.next')"></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import Store from '@/store'
    import CountryBackendEnum from 'enums/country_backend.enum'

    export default {
        mixins: [FormMixin],

        props: {
            countryOptions: { type: Array, required: true },
        },

        data: () => ({
            cityOptions: [],
            isSubdomainActive: false,
            containerDimensions: undefined,
            allCountries: Store.getters['data/getCountries'],
        }),

        methods: {
            submit() {
                this.emitEvent({ name: 'company-data-success', payload: this.data })
            },

            fetchCities(selectedCountry) {
                this.cityOptions = Store.getters['data/getCountries']
                    .find((country) => country.name === selectedCountry)
                    .cities.map((city) => ({
                        value: city.id,
                        label: city.name,
                    }))
            },

            prefillCompanyForm() {
                const dataForPrefill = {}
                let selectedCountry
                if (Store?.getters['data/getCountryByGeolocation']) {
                    selectedCountry = this.allCountries.find(
                        (country) => country.id === Store?.getters['data/getCountryByGeolocation'],
                    )
                } else {
                    selectedCountry = this.allCountries.find((country) => country.id === CountryBackendEnum.SERBIA.id)
                }

                dataForPrefill.countryId = selectedCountry?.name
                this.fetchCities(selectedCountry?.name)
                this.prefillData(dataForPrefill)
            },

            countryChange(event) {
                this.change(event)
                this.$refs.citySelect.searchTerm = ''
                this.fetchCities(event.value)
            },

            toggleSubdomain() {
                this.isSubdomainActive = !this.isSubdomainActive
            },

            getContainerDimensions() {
                const el = document.getElementsByClassName('form create-company-form')[0]
                if (el) {
                    this.containerDimensions = { width: el.clientWidth }
                }
            },
        },

        mounted() {
            this.getContainerDimensions()
            this.prefillCompanyForm()
        },
    }
</script>
